<template>
  <billing-closed-container />
  <tr-loading
    v-if="isLoading"
    classes="center-h-and-v width-100 vertical-offset5"
  />
  <template
    v-if="billing && billing.length && !isLoading"
  >
    <billing-table
      :billing="billing"
      :get-monthly-report="getMonthlyReport"
      :download-billet="download"
      :is-billet-downloading="isDownloading"
    />
    <tr-typography classes="vertical-offset4">
      Caso você tenha dúvidas ou existam informações incorretas, entre em contato pelo e-mail suporte@transfeera.com.
    </tr-typography>
  </template>
  <billing-blankslate v-if="!billing.length && !isLoading" />
</template>

<script setup>
import { ref } from 'vue';
import BillingBlankslate from '@/apps/admin/billing/components/presentational/BillingBlankslate.vue';
import BillingTable from '@/apps/admin/billing/components/presentational/BillingTable.vue';
import BillingClosedContainer from '@/apps/admin/billing/components/container/BillingClosedContainer.vue';
import billingResource from '@/apps/admin/billing/resources/billing';
import { useBilletDownload } from '@/apps/admin/billing/composables/useBilletDownload';
import { useToaster } from '@/commons/composables/useToaster';
import { getMessage } from '@/commons/services/error';

const toaster = useToaster();
const { isDownloading, download } = useBilletDownload();

const billing = ref([]);
const isLoading = ref(false);

const getMonthlyReport = async billingStartPeriod => {
  try {
    await billingResource.getMonthlyReport(billingStartPeriod);
    toaster.success({
      message: 'Relatório está sendo gerado, quando concluído será enviado para o seu email.',
      duration: 10000
    });
  } catch (error) {
    toaster.error(getMessage(error));
  }
};

isLoading.value = true;
billingResource.get().then(
  data => {
    billing.value = data;
    isLoading.value = false;
  },
  error => toaster.error(getMessage(error))
);
</script>
